import CardDetails from './card-details';

export default CardDetails;
